import React from 'react';
import PropTypes from 'prop-types';
import classnamesBind from 'classnames/bind';

const FooterText = (props) => {
    const {
        center,
        className,
        cssBlock,
        styles,
        ...otherProps
    } = props;

    const classnames = classnamesBind.bind(styles);

    const classes = classnames(
        `${cssBlock}__text`,
        className,
        {
            [`${cssBlock}__text--center`]: center,
        },
    );

    return (
        <div
            {...otherProps}
            className={classes}
        />
    );
};

FooterText.displayName = 'FooterText';

FooterText.propTypes = {
    center: PropTypes.bool,
    className: PropTypes.string,
    cssBlock: PropTypes.string,
    styles: PropTypes.object,
};

export default FooterText;
